import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProveedorService } from 'src/app/global/services/proveedor-servicios.service';
import { ProveedorServiceVM } from 'src/app/view-model/services/proveedor-vm.service';


@Injectable()
export class ProveedorProviderVM extends ProveedorServiceVM {
    constructor(private proveedorService: ProveedorService) {
        super();
    }

    getProveedores(): Observable<any> {

        return this.proveedorService.getProveedores().pipe(
            (map(this.getProveedoresOK), catchError(this.serviceError))
        );
    }

    private getProveedoresOK(resp) {
        return resp;
    }

    private serviceError(error) {
        return throwError(error);
    }
}